<template>
  <Overlay>
    <slot name="content">
      <div
        class="visitorInfoForm"
        :style="{ ...getFontSizeForChatInterface('bodyText') }"
      >
        <div class="header">
          <div @click="handleCancel">
            <BaseIcon class="close-icon" name="CloseIcon" />
          </div>
          <p :style="{ ...getFontSizeForChatInterface('title') }">
            Visitor information
          </p>
        </div>
        <div class="form-detail">
          <p :style="{ ...getFontSizeForChatInterface('smallBodyText') }">
            Use visitor details to generate a response.
          </p>
          <textarea
            v-model="visitorInfo"
            :placeholder="visitorInfoPlaceholder"
          />
          <p v-if="jsonError" class="error">Enter a valid json</p>
        </div>
        <div class="footer">
          <button class="cancel-btn" @click="handleCancel">Cancel</button>
          <button
            class="submit-btn"
            :disabled="!isVisitorInfoChanged"
            @click="handleSubmit"
          >
            Submit
          </button>
        </div>
      </div>
    </slot>
  </Overlay>
</template>

<script>
import Overlay from './Overlay.vue'
import BaseIcon from '@/views/BaseIcon.vue'
import { showMessageSeparatorPill } from '@/services/utils'
import fontSizeMixin from '@/mixins/fontSizeMixin'

export default {
  name: 'VisitorInfoForm',
  components: {
    Overlay,
    BaseIcon
  },
  mixins: [fontSizeMixin],
  data() {
    return {
      visitorInfo: '',
      jsonError: false
    }
  },
  computed: {
    visitorInfoFromState() {
      return this.$store.state.visitorInfoForm.visitorInfoDetails
        ? JSON.stringify(
            this.$store.state.visitorInfoForm.visitorInfoDetails,
            null,
            2
          )
        : ''
    },
    isVisitorInfoChanged() {
      return this.visitorInfoFromState !== this.visitorInfo
    },
    visitorInfoPlaceholder() {
      return `{\n"user_email": "andy@email.com",\n"user_member_number": "ABC123"\n}`
    }
  },
  mounted() {
    this.visitorInfo = this.visitorInfoFromState
  },
  methods: {
    handleCancel() {
      this.$store.dispatch('showVisitorInfoForm', false)
    },
    handleSubmit() {
      try {
        const parsedJson = JSON.parse(this.visitorInfo)
        if (Array.isArray(parsedJson)) {
          throw new Error()
        }
        this.jsonError = false
        this.$store.dispatch('updateVisitorInfoForm', parsedJson)
        this.$store.dispatch('showVisitorInfoForm', false)
      } catch {
        this.jsonError = true
        return
      }
      showMessageSeparatorPill({
        message: 'Visitor information updated',
        isEndChatSeparator: false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css/theme.scss';
:deep(.overlayDiv) {
  background: rgba(0, 0, 0, 0.3) !important;

  .visitorInfoForm {
    display: flex;
    flex-direction: column;
    background: #fff;
    width: 80%;
    height: 75%;
    margin: 80px auto;
    position: relative;
    border-radius: 4px;
    overflow: hidden;

    .header {
      padding: 32px;
      .close-icon {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
      }

      p {
        font-weight: 500;
      }
    }
    .form-detail {
      flex: 1;
      padding: 32px;
      padding-top: 0;
      display: flex;
      flex-direction: column;
      gap: 8px;

      p {
        font-weight: 500;

        &.error {
          color: #b50000;
        }
      }

      textarea {
        height: 100%;
        max-height: 100%;
        max-width: 100%;
        white-space: pre-wrap;
        max-width: 100%;
        word-wrap: break-word;
        padding: 10px;
        font-size: inherit;
      }
    }

    .footer {
      display: flex;
      justify-content: flex-end;
      padding: 16px 32px;
      border-top: 1px solid #e7eaec;

      .cancel-btn {
        background: none;
        font-size: inherit;
        width: 100px;
        height: 40px;
        @include border-radius(var(--radius-chat-inner-component));
        border: none;
        font-weight: 600;
        cursor: pointer;
      }

      .submit-btn {
        background: #000000;
        font-size: inherit;
        color: #fff;
        width: 100px;
        height: 40px;
        font-weight: 600;
        @include border-radius(var(--radius-chat-inner-component));
        cursor: pointer;

        &:disabled {
          cursor: not-allowed;
          background-color: rgba(0, 0, 0, 0.09);
          color: #000;
        }
      }
    }
  }
}
</style>
